import * as React from 'preact/compat'
import type { SvelteComponent } from 'svelte'

type ExtractProps<Ctor> = Ctor extends new (arg: any) => SvelteComponent<infer Props> ? Props & {
  SvelteContainerOptions?: React.JSX.HTMLAttributes<HTMLDivElement>
} : Record<string, any>

export default function SvelteWrapper<CompCtor extends new (arg: any) => SvelteComponent>(Component: CompCtor) {
  const render = (props: ExtractProps<CompCtor>, ref?: React.Ref<SvelteComponent>) => {
    if (!ref) {
      ref = React.createRef();
    }
    const svelteRef = React.useRef<HTMLDivElement>();
    React.useLayoutEffect(() => {
      const propsReal = { ...props }
      delete propsReal.SvelteContainerOptions
      while (svelteRef.current?.firstChild) {
        svelteRef.current?.firstChild?.remove();
      }
      // @ts-ignore
      // noinspection JSConstantReassignment
      ref.current = new Component({
        target: svelteRef.current,
        props,
      });
    }, []);
    return <div ref={svelteRef} {...(props.SvelteContainerOptions ?? {})}></div>;
  };
  return React.forwardRef(render);
}
